<script>
import axios from 'axios'
import { authMethods, appMethods } from '@state/helpers'

export default {
  props: {
    user: { type: Object, required: true },
    dropdown: { type: Object, required: true },
  },
  data: function() {
    return {
      form: {
        title: this.user.title,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        countryId: this.user.country.id,
      },
      loading: false,
    }
  },
  methods: {
    ...appMethods,
    ...authMethods,
    submit() {
      this.loading = true
      axios
        .post('/api/v2/update_profile', this.form)
        .then(() => {
          this.loading = false
          this.showAlert({ message: 'Profile updated successfuly.' })
          this.validate()
        })
        .catch(() => {
          this.loading = false
          this.showAlert({
            type: 'error',
            message: 'Failed to update your profile.',
          })
          //
        })
    },
  },
}
</script>

<template>
  <div class="border border-gray-500 rounded-sm h-full bg-gray-100">
    <div class="py-4 px-3 bg-white">
      <h4 class="font-medium">Profile</h4>
    </div>
    <div class="flex flex-wrap pt-6">
      <div class="w-full">
        <ValidationObserver v-slot="{ invalid, passes }" slim>
          <form @submit.prevent="passes(submit)">
            <BaseSelect
              v-model="form.title"
              class="md:w-1/5"
              label="Title"
              rules="required"
              :items="dropdown.titles"
            />
            <!-- title -->

            <BaseInput
              v-model="form.firstName"
              label="First Name"
              rules="required|min:3"
            />
            <!-- first name -->

            <BaseInput
              v-model="form.lastName"
              label="Last Name"
              rules="required|min:3"
            />
            <!-- last name -->

            <BaseSelect
              v-model="form.countryId"
              label="Country"
              rules="required"
              :items="dropdown.countries"
            />
            <!-- country -->

            <div class="w-full mb-6 px-3 text-right">
              <button
                type="submit"
                class="btn btn-gold"
                :class="{ 'btn-disabled': invalid || loading }"
                :disabled="invalid || loading"
                @click="submit"
              >
                <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-else>Update Profile</span>
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
